import { ControlItemValue } from '../types/types';

// Type guard: only primitives are usable as an option value
export const isControlItemValue = (
  value: unknown
): value is ControlItemValue => {
  return (
    typeof value === 'string' ||
    typeof value === 'number' ||
    typeof value === 'boolean'
  );
};
